import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ShopContext = createContext(null);

const loadCart = () => {
  try {
    return JSON.parse(localStorage.getItem("rl_cart") || "[]");
  } catch {
    return [];
  }
};

export const itemKey = (it) => `${it.slug}::${it.variant || ""}`;

export function ShopProvider({ children }) {
  const [cart, setCart] = useState(loadCart);
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("rl_cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = useCallback((product, qty = 1, variant = null) => {
    const v = variant || product.variants?.[0]?.name || null;
    const image = (v && product.variants?.find((x) => x.name === v)?.image) || product.images[0];
    const key = itemKey({ slug: product.slug, variant: v });
    setCart((prev) => {
      const i = prev.findIndex((it) => itemKey(it) === key);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: Math.min(20, next[i].qty + qty) };
        return next;
      }
      return [...prev, { slug: product.slug, variant: v, name: product.name, price: product.price, image, qty }];
    });
    setCartOpen(true);
  }, []);

  const updateQty = useCallback((key, qty) => {
    setCart((prev) => (qty <= 0 ? prev.filter((it) => itemKey(it) !== key) : prev.map((it) => (itemKey(it) === key ? { ...it, qty } : it))));
  }, []);

  const removeItem = useCallback((key) => {
    setCart((prev) => prev.filter((it) => itemKey(it) !== key));
  }, []);

  const clearCart = useCallback(() => setCart([]), []);

  const cartCount = cart.reduce((a, it) => a + it.qty, 0);
  const subtotal = cart.reduce((a, it) => a + it.qty * it.price, 0);

  return (
    <ShopContext.Provider value={{
      cart, cartCount, subtotal,
      addToCart, updateQty, removeItem, clearCart,
      cartOpen, setCartOpen,
    }}>
      {children}
    </ShopContext.Provider>
  );
}

export const useShop = () => useContext(ShopContext);
